import { FlightSearchResult, SelectedFlight } from "@/core/types/types";

const flightMapper = {
  fromSearchResult: (
    flightSearchResult: FlightSearchResult
  ): SelectedFlight => {
    return {
      routeOrder: 1, // TODO: change for multi leg flights
      flightNumber: flightSearchResult.operatingAirlineCode.concat(
        flightSearchResult.flightNumber
      ),
      departureAirportIata: flightSearchResult.departureAirportIata,
      arrivalAirportIata: flightSearchResult.arrivalAirportIata,
      scheduledDepartureDateTime: flightSearchResult.scheduledDeparture,
      scheduledArrivalDateTime: flightSearchResult.scheduledArrival,
      actualArrivalDateTime: flightSearchResult.actualArrival,
      actualDepartureDateTime: flightSearchResult.actualDeparture,
      isTransportTaken: true, // TODO: change in the future depending on the problem type
      incident: flightSearchResult.status.toUpperCase(),
    };
  },
};

export { flightMapper };
